var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClosed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 46,
    viewBox: "0 0 37 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2153 21.0833H8.90639L10.8655 18.6108C11.1493 18.2499 11.3087 17.7604 11.3087 17.2499C11.3087 16.7395 11.1493 16.25 10.8655 15.8891C10.5817 15.5282 10.1968 15.3254 9.79552 15.3254C9.3942 15.3254 9.00932 15.5282 8.72555 15.8891L4.20456 21.6391C4.06331 21.8173 3.9512 22.0293 3.87469 22.2628C3.79818 22.4964 3.75879 22.7469 3.75879 22.9999C3.75879 23.253 3.79818 23.5035 3.87469 23.7371C3.9512 23.9706 4.06331 24.1826 4.20456 24.3608L8.72555 30.1108C8.86564 30.2904 9.03232 30.433 9.21596 30.5303C9.3996 30.6276 9.59658 30.6777 9.79552 30.6777C9.99446 30.6777 10.1914 30.6276 10.3751 30.5303C10.5587 30.433 10.7254 30.2904 10.8655 30.1108C11.0067 29.9326 11.1188 29.7206 11.1954 29.4871C11.2719 29.2535 11.3113 29.003 11.3113 28.7499C11.3113 28.4969 11.2719 28.2464 11.1954 28.0128C11.1188 27.7793 11.0067 27.5673 10.8655 27.3891L8.90639 24.9166H30.2153C30.5891 24.8934 30.9428 24.6941 31.2074 24.3575C31.472 24.021 31.6287 23.5712 31.647 23.0958V22.9999C31.6475 22.5078 31.4991 22.0343 31.2326 21.6774C30.966 21.3206 30.6018 21.1079 30.2153 21.0833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2153 32.5833H5.95264C5.16197 32.5833 4.521 33.3985 4.521 34.4041V34.5958C4.521 35.6014 5.16197 36.4166 5.95264 36.4166H30.2153C31.006 36.4166 31.6469 35.6014 31.6469 34.5958V34.4041C31.6469 33.3985 31.006 32.5833 30.2153 32.5833Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2153 9.58325H5.95264C5.16197 9.58325 4.521 10.3985 4.521 11.4041V11.5958C4.521 12.6014 5.16197 13.4166 5.95264 13.4166H30.2153C31.006 13.4166 31.6469 12.6014 31.6469 11.5958V11.4041C31.6469 10.3985 31.006 9.58325 30.2153 9.58325Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClosed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/closed.1efb8b568a4d4c68818d694e873b3847.svg";